import { useLocation, useMatch } from "react-router-dom";

export function useRouteMatch(pattern = "*") {
  const location = useLocation();
  const match = useMatch(pattern);

  if (match) {
    return {
      params: match.params,
      path: pattern,
      url: match.pathname,
      isExact: match.pathname === location.pathname,
    };
  }

  return {
    params: {},
    path: location.pathname,
    url: location.pathname,
    isExact: true,
  };
}